/** Lookup map for actions available per state in each of supported state machines */
export = {
	SimpleApprove: {
		"Revision.State:DRAFT": {
			Approve: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:APPROVED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	SimpleRevision: {
		"Revision.State:DRAFT": {
			Approve: true,
			ReviseAndAbandon: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:PENDING": {
		},
		"Revision.State:APPROVED": {
			RevertToDraft: true,
		},
		"Revision.State:ABANDONED": {
		},
		"Revision.State:SUPERSEDED": {
		},
		"Revision.State:MANAGED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	DocumentRevision: {
		"Revision.State:DRAFT": {
			MakePending: true,
			Approve: true,
			StartApprovalWorkflow: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:PENDING": {
			Approve: true,
			RevertToDraft: true,
			StartApprovalWorkflow: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:APPROVED": {
			Revise: true,
			CloseRevision: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:CLOSED": {
			Revise: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:SUPERSEDED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	DocumentRevisionConfirm: {
		"Revision.State:DRAFT": {
			MakePending: true,
			ApproveConfirm: true,
			StartApprovalWorkflow: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:PENDING": {
			ApproveConfirm: true,
			RevertToDraft: true,
			StartApprovalWorkflow: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:APPROVED": {
			MassUpdateDataSheets: true,
			Revise: true,
			CloseRevision: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:CLOSED": {
			Revise: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:SUPERSEDED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	DocumentRevisionNoClosed: {
		"Revision.State:DRAFT": {
			MakePending: true,
			Approve: true,
			StartApprovalWorkflow: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:PENDING": {
			Approve: true,
			RevertToDraft: true,
			StartApprovalWorkflow: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:APPROVED": {
			Revise: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:SUPERSEDED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	DocumentRevisionNoPending: {
		"Revision.State:DRAFT": {
			Approve: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
			StartApprovalWorkflow: true,
		},
		"Revision.State:APPROVED": {
			Revise: true,
			CloseRevision: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:CLOSED": {
			Revise: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:SUPERSEDED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	DGaaSRevision: {
		"Revision.State:DRAFT": {
			Approve: true,
			PurgeAllPreviousRevisions: true,
			PurgeRevisions: false,
			StartApprovalWorkflow: true,
		},
		"Revision.State:APPROVED": {
			PurgeAllPreviousRevisions: true,
			PurgeRevisions: false,
			RevertToDraft: true,
		},
		"Revision.State:SUPERSEDED": {
			PurgeAllPreviousRevisions: true,
			PurgeRevisions: false,
		},
		"Revision.State:MANAGED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	NegotiatedDocumentRevision: {
		"Revision.State:DRAFT": {
			MakePending: true,
			Approve: true,
			StartApprovalWorkflow: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:PENDING": {
			Approve: true,
			MakePending2: true,
			RevertToDraft: true,
			StartApprovalWorkflow: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:PENDING2": {
			Approve: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:APPROVED": {
			Revise: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:SUPERSEDED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	OperationsReviewRevision: {
		"Revision.State:DRAFT": {
			MakePending: true,
			Approve: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:PENDING": {
			Approve: true,
			RevertToDraft: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	OperationsReviewRevisionExpress: {
		"Revision.State:DRAFT": {
			Approve: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	PhasedRevision: {
		"Revision.State:ABANDONED": {
			ReopenPhase: true,
		},
		"Revision.State:APPROVED": {
			ReopenPhase: true,
		},
		"Revision.State:DRAFT": {
			Abandon: true,
			EndPhase: true,
			MakePending: true,
			ReviseAndAbandon: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:PENDING": {
			EndPhase: true,
			MakePending2: true,
			ReopenPhase: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:PENDING2": {
			Abandon: true,
			EndPhase: true,
			ReviseAndAbandon: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:MANAGED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	PhasedReviewRevision: {
		"Revision.State:ABANDONED": {
			ReopenPhase: true,
		},
		"Revision.State:APPROVED": {
			ReopenPhase: true,
		},
		"Revision.State:DRAFT": {
			Abandon: true,
			EndPhase: true,
			MakePending: true,
			ReviewStart: true,
			ReviewReopen: true,
			ReviseAndAbandon: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:PENDING": {
			EndPhase: true,
			ReviewStart: true,
			ReviewReopen: true,
			MakePending2: true,
			ReopenPhase: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:PENDING2": {
			Abandon: true,
			EndPhase: true,
			ReviewStart: true,
			ReviewReopen: true,
			ReviseAndAbandon: true,
			StartApprovalWorkflow: false,
		},
		"Revision.State:REVIEW": {
			ReviewFail: true,
			ReviewApprove: true,
			ReviewCancel: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:MANAGED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	SupplierItemRevision: {
		"Revision.State:ABANDONED": {
			ReopenPhase: true,
		},
		"Revision.State:APPROVED": {
			CloseRevision: true,
			ReopenPhase: true,
		},
		"Revision.State:CLOSED": {
		},
		"Revision.State:DRAFT": {
			Abandon: true,
			Approve: true,
			ReopenPhase: true,
			ReviseAndAbandon: true,
			MakePending: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:PENDING": {
			Abandon: true,
			Approve: true,
			CancelOffline: true,
			ReopenPhase: true,
			StartApprovalWorkflow: true,
		},
	},
	FoodSupplierItemRevision: {
		"Revision.State:ABANDONED": {
			ReopenPhase: true,
		},
		"Revision.State:APPROVED": {
			CloseRevision: true,
			ReopenPhase: true,
		},
		"Revision.State:CLOSED": {
		},
		"Revision.State:DRAFT": {
			Abandon: true,
			Approve: true,
			ReviseAndAbandon: true,
			MakePending: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:PENDING": {
			Abandon: true,
			Approve: true,
			CancelOffline: true,
			ReopenPhase: true,
			StartApprovalWorkflow: true,
		},
	},
	SpecificationDataSheetSupplierResponseRevision: {
		"Revision.State:APPROVED": {
			ReopenPhase: true,
		},
		"Revision.State:CLOSED": {
			ReopenPhase: true,
		},
		"Revision.State:DRAFT": {
			Approve: true,
			CloseRevision: true,
			ReviseAndAbandon: true,
			MakePending: true,
		},
		"Revision.State:PENDING": {
			Approve: true,
			CancelOffline: true,
			CloseRevision: true,
			ReopenPhase: true,
		},
	},
	AffectedSpecRevision: {
		"Revision.State:DRAFT": {
			Abandon: true,
			ReviseAndAbandon: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	ProofingRevision: {
		"Revision.State:DRAFT": {
			MakePending: true,
			Approve: true,
			StartApprovalWorkflow: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:PENDING": {
			Approve: true,
			RevertToDraft: true,
			StartApprovalWorkflow: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:APPROVED": {
			Revise: true,
			CloseRevision: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:CLOSED": {
			Revise: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:SUPERSEDED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	RecipeDataSheetRevision: {
		"Revision.State:ABANDONED": {
			ReopenPhase: true,
		},
		"Revision.State:APPROVED": {
			ReopenPhase: true,
		},
		"Revision.State:DRAFT": {
			Abandon: true,
			EndPhase: true,
			MakePending: true,
			ReviseAndAbandon: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:PENDING": {
			EndPhase: true,
			ReopenPhase: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:PENDING2": {
			Abandon: true,
			EndPhase: true,
			ReviseAndAbandon: true,
			StartApprovalWorkflow: true,
		},
		"Revision.State:MANAGED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
	SourceBOMRevision: {
		"Revision.State:DRAFT": {
			MakePending: true,
			Approve: true,
			Abandon: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:PENDING": {
			ReopenPhase: true,
			Approve: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:APPROVED": {
			ReopenPhase: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:ABANDONED": {
			ReopenPhase: true,
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
		"Revision.State:MANAGED": {
			PurgeRevisions: false,
			PurgeResetRevisions: false,
		},
	},
};
